<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">New Collection</p>
    </header>
    <section class="modal-card-body">
      <b-notification
        @close="resetErrors"
        :active="newCollectionErrors != null"
        type="is-danger"
        has-icon
        aria-close-label="Close notification"
        role="alert"
      >
        {{ newCollectionErrors }}
      </b-notification>

      <span>
        <b-field label="Collection name">
          <b-input
            maxlength="50"
            placeholder="Naruto"
            v-model="collection.name"
          ></b-input>
        </b-field>

        <b-field>
          <template slot="label">
            Visibility
            <b-tooltip
              position="is-right"
              type="is-dark"
              multilined
              size="is-small"
              label="Change visiblity to public so that everyone can enjoy your collection!"
            >
              <b-icon size="is-small" type="is-gray" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <b-switch
            v-model="collection.hidden"
            passive-type="is-warning"
            type="is-success"
            :true-value="false"
            :false-value="true"
          >
            <span v-if="!collection.hidden">
              <b-icon size="" type="" icon="earth"></b-icon>
              Public
              <span class="is-italic">(Everyone can view this Collection)</span>
            </span>
            <span v-else>
              <b-icon size="" type="" icon="lock"></b-icon>
              Private
              <span class="is-italic">(Only you can view this Collection)</span></span
            >
          </b-switch>
        </b-field>
      </span>
    </section>

    <footer class="modal-card-foot">
      <span class="card-footer-item">
        <b-button @click="create" type="is-success" icon-pack="mdi" icon-right="check">
          Create
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="$parent.close()"> Close </b-button>
      </span>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  data () {
    return {
      collection: {
        name: null,
        hidden: false
      },
      newCollectionErrors: null
    }
  },
  methods: {
    create () {
      let payload = {
        user: this.currentUser.attributes.username,
        payload: this.collection
      }
      this.$store
        .dispatch('users/collections/create', payload)
        .then((resp) => {
          this.$emit('collectionCreated', resp.data.data)
          this.$parent.close()
        })
        .catch((error) => {
          console.log(error)
          this.newCollectionErrors = error
        })
    },
    resetErrors () {
      this.newCollectionErrors = null
    }
  }
}
</script>
